// extracted by mini-css-extract-plugin
module.exports = {"container":"Reviews_container__zI0sw","wrapper":"Reviews_wrapper__oKLyz"};